export default {
      id: "close-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#close",
      toString: function () {
        return this.url;
      }
    }